"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollDown;

var _react = require("react");

var _useScrollRelative = _interopRequireDefault(require("./internal/useScrollRelative"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollDown() {
  var scrollRelative = (0, _useScrollRelative.default)();
  return (0, _react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return scrollRelative.apply(void 0, ['down'].concat(args));
  }, [scrollRelative]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTY3JvbGxEb3duLnRzIl0sIm5hbWVzIjpbInVzZVNjcm9sbERvd24iLCJzY3JvbGxSZWxhdGl2ZSIsImFyZ3MiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQTs7OztBQUVlLFNBQVNBLGFBQVQsR0FBdUU7QUFDcEYsTUFBTUMsY0FBYyxHQUFHLGlDQUF2QjtBQUVBLFNBQU8sd0JBQVk7QUFBQSxzQ0FBSUMsSUFBSjtBQUFJQSxNQUFBQSxJQUFKO0FBQUE7O0FBQUEsV0FBYUQsY0FBYyxNQUFkLFVBQWUsTUFBZixTQUEwQkMsSUFBMUIsRUFBYjtBQUFBLEdBQVosRUFBMEQsQ0FBQ0QsY0FBRCxDQUExRCxDQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUNhbGxiYWNrIH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgdXNlU2Nyb2xsUmVsYXRpdmUgZnJvbSAnLi9pbnRlcm5hbC91c2VTY3JvbGxSZWxhdGl2ZSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNjcm9sbERvd24oKTogKG9wdGlvbnM/OiB7IGRpc3BsYWNlbWVudDogbnVtYmVyIH0pID0+IHZvaWQge1xuICBjb25zdCBzY3JvbGxSZWxhdGl2ZSA9IHVzZVNjcm9sbFJlbGF0aXZlKCk7XG5cbiAgcmV0dXJuIHVzZUNhbGxiYWNrKCguLi5hcmdzKSA9PiBzY3JvbGxSZWxhdGl2ZSgnZG93bicsIC4uLmFyZ3MpLCBbc2Nyb2xsUmVsYXRpdmVdKTtcbn1cbiJdfQ==